import React from 'react'
import { StyleProp, TextProps, TextStyle } from 'react-native'

import { useFontFlowStore } from '../store/fontFlowStore'

type FontOptions =
  | 'Graphie-Bold'
  | 'Graphie-Book'
  | 'Graphie-Regular'
  | 'Graphie-SemiBold'
  | 'JioType-Bold'
  | 'JioType-Medium'
  | 'JioType-Black'
  | 'JioType-Light'
  | 'JioType'

export const withFont = <P extends TextProps>(
  WrappedComponent: React.ComponentType<P>,
  options?: {
    fontForJfsFlow?: FontOptions
    fontDefault?: FontOptions
  }
) => {
  return (props: P) => {
    const isJfsFlow = useFontFlowStore((state) => state.isJfsFlow)

    const fontFamily = isJfsFlow
      ? options?.fontForJfsFlow || 'Graphie-SemiBold'
      : options?.fontDefault || 'JioType-Medium'

    const combinedStyle: StyleProp<TextStyle> = [{ fontFamily }, props.style]

    return <WrappedComponent {...props} style={combinedStyle} />
  }
}
